import React, { memo } from "react";

const NavItem = (props) => {
  const { Name, vehicleType, NavImage } = props.item;

  const chkMobile = () => {
    if (NavImage !== "") {
      return (
        <span className="nav-link d-md-none" onClick={vehicleTypeClicked}>
          <img src={NavImage} alt="vehicle-type" />
        </span>
      );
    } else {
      return "";
    }
  };

  const vehicleTypeClicked = () => {
    props.clicked(vehicleType);
  };

  return (
    <li className={`nav-item ${props.isActive && "active"}`}>
      <span
        className={`nav-link ${NavImage !== "" && "d-none d-md-block"} `}
        href="#"
        style={{ cursor: "pointer" }}
        onClick={vehicleTypeClicked}
      >
        {Name}
      </span>
      {chkMobile()}
    </li>
  );
};

export default memo(NavItem);
